/*
 * blankLibraries.js — trimmed version
 *
 * This file previously contained ~1,000 lines of mostly-dead code including
 * fancyBox v2.1.5, ~17 module definitions (coreUI, bbModal, AddToCart, CartQTY,
 * bbCart, bbCheckout, FadeIn, GeoLocation, ProductPage, QtyChangerAtc, Scroll,
 * Search, Blog, Article, Sliders, BackToTop, eventTracking), and a beforeAfter
 * jQuery plugin — all wrapped in /* ... *\/ blocks and never executed.
 *
 * What's actually used in this theme:
 *   1. jQuery.cookie  — used by blankInitialize.js for popAnnounce cookie
 *   2. GlobalHeader   — called from theme.liquid for mobile nav + scroll behavior
 *
 * Bug fix: Mobile nav click handlers were previously wrapped in a one-time
 * `if ($(window).width() < 767)` check, which meant the hamburger menu was
 * unresponsive when users loaded the page wide and then resized narrow.
 * Handlers are now always attached — they target mobile-only elements that
 * are hidden by CSS at desktop sizes, so this is safe.
 */

/*
 * jQuery Cookie Plugin
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses
 */
jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
};

/*
 * GlobalHeader — mobile navigation and scroll-state for the site header.
 * Called from theme.liquid via safeInitGlobalHeader().
 */
!function(GlobalHeader, $) {
    GlobalHeader.init = function() {
        // Mobile nav handlers — always attached, regardless of viewport width.
        // The targeted elements ([nav-toggle], .navParent-link, etc.) are
        // hidden by CSS at desktop widths, so attaching at all sizes is safe
        // and fixes the resize-from-wide-to-narrow dead zone bug.
        $('#Shop').siblings('.navChildren').addClass('is-active');

        $(".navParent-link").click(function(e) {
            if ($(this).siblings('.navChildren').length) {
                e.preventDefault();
                if ($(this).siblings('.navChildren').hasClass('is-active')) {
                    $(this).siblings('.navChildren').removeClass("is-active").attr('aria-hidden', 'true');
                } else {
                    $(".navChildren.is-active").removeClass("is-active").attr('aria-hidden', 'true');
                    $(this).siblings('.navChildren').addClass("is-active").attr('aria-hidden', 'false');
                }
            }
        });

        $(".navChild-link").click(function(e) {
            if ($(this).siblings('.navGrandchildren').length) {
                e.preventDefault();
                if ($(this).siblings(".navGrandchildren").hasClass('is-active')) {
                    $(this).siblings(".navGrandchildren").removeClass("is-active").attr('aria-hidden', 'true');
                } else {
                    $(".navGrandchildren.is-active").removeClass("is-active").attr('aria-hidden', 'true');
                    $(this).siblings(".navGrandchildren").addClass("is-active").attr('aria-hidden', 'false');
                }
            }
        });

        $("[nav-back]").click(function(e) {
            if ($('.navChildren.is-active').length) {
                $('.navChildren.is-active').removeClass("is-active");
            } else {
                $('#bbNav').removeClass("is-active");
            }
        });

        $("[nav-toggle]").click(function() {
            $(this).toggleClass("is-active"),
            $("#bbNav").toggleClass("is-active");
        });

        $('#bbNav').on('click', function() {
            if ($('.navChildren').hasClass('is-active')) {
                $('[nav-back]').addClass('is-active');
            } else {
                $('[nav-back]').removeClass('is-active');
            }
        });

        // Scroll-state for header — runs at all widths.
        $(window).scroll(function() {
            if ($(this).scrollTop() > 50) {
                $('#bbNav').addClass('scrolled');
            } else {
                $('#bbNav').removeClass('scrolled');
            }
        });
    }
}(window.GlobalHeader = window.GlobalHeader || {}, jQuery);
